const config = require('./config.yaml');

var $accordion = $('.accordion--no-hash');

if (config.showArticleCloseBtnCondition == 'always') {
	$('.accordion__article').append('<div class="article-close"></div>');
}

global.updateAccordionsNoHashSelectors = function () {
	$accordion = $('.accordion--no-hash');
};

function openAccordion(currentElem) {
	var $thisSection = currentElem.closest('.accordion__section');

	$thisSection
		.children('.accordion__header')
		.children('.accordion__button')
		.addClass('is-expand');
	$thisSection
		.children('.accordion__article')
		.addClass('is-expand')
		.velocity('slideDown');

	if (config.accordionIsSingle) {
		const $sectionForClose = $thisSection
			.siblings('.accordion__section')
			.find('.accordion__button.is-expand');

		closeAccordion($sectionForClose);
	}

	if (config.showArticleCloseBtnCondition == 'longerThanWindow') {
		const currentSectionHeight = $thisSection.children('.accordion__header').height() + $thisSection.children('.accordion__article').innerHeight();

		if (currentSectionHeight > $(window).height() && !$thisSection.find('.article-close').length) {
			$thisSection.find('.accordion__article').append('<div class="article-close"></div>');
		}
	}
}

$(document).on('click', '.accordion--no-hash .accordion__button', function () {
	const $this = $(this);

	if ($this.hasClass('is-expand')) {
		closeAccordion($this);
	} else {
		openAccordion($this);
	}
});

function closeAccordion($element) {
	var $enclosedAccordion = $element.closest('.accordion__section');

	if (config.scrollOnClose) {
		scrollToElement($element.attr('href'));
	}

	slideUpAddClasses($enclosedAccordion);
}

function slideUpAddClasses(elem) {
	if (config.closeInsideAccordionsOnClose) {
		elem
			.find('.accordion__button')
			.removeClass('is-expand');
		elem
			.find('.accordion__article')
			.removeClass('is-expand')
			.velocity('slideUp');
	} else {
		elem
			.children('.accordion__header')
			.children('.accordion__button')
			.removeClass('is-expand');
		elem
			.children('.accordion__article')
			.removeClass('is-expand')
			.velocity('slideUp');
	}
}

function closeAccordionEvent(event) {
	event.preventDefault();
	closeAccordion($(this));
}

function scrollToElement(href) {
	var topPos = $(`[href="${href}"]`).offset().top;
	$('html')
		.velocity('scroll', {
			offset: topPos + 'px',
			duration: 400,
			mobileHA: false
		});
}

// $(document).on('click', '.accordion--no-hash .accordion__button.is-expand', closeAccordionEvent);
$(document).on('click', '.accordion--no-hash .article-close', function () {
	var $element = $(this).closest('.accordion__section').find('.accordion__button.is-expand');

	closeAccordion($element);
});

if (config.scrollOnOpen) {
	$(document).on('click', '.accordion--no-hash .accordion__button', function () {
		scrollToElement($(this).attr('href'));
	});
}

$('.control-item--expand').on('click', function () {

	$(this).closest('.accordion--no-hash').find('.accordion__button').each(function (i, elem) {
		const $this = $(elem);

		openAccordion($this);
	});
});

$('.control-item--collapse').on('click', function () {
	$(this).closest('.accordion--no-hash').find('.accordion__button').each(function (i, elem) {
		const currentHref = $(elem).attr('href');
		const currentSection = $(elem).closest('.accordion__section');

		slideUpAddClasses(currentSection);
	});
});



// WEBPACK FOOTER //
// ./temp/components/accordions/accordion-no-hash/index.js